import { model, Model, prop, modelAction } from "mobx-keystone";
import { PayInAssetCode } from "../helpers/constants";

@model("lightningswap/NewSwapQuote")
export class NewSwapQuote extends Model({
  asset:              prop<PayInAssetCode | null>(null),
  bolt11:             prop<string>(""),
  parsedBolt11:       prop<string | null>(null),
  invoiceSats:        prop<number | null>(null),
  invoiceExpiresAt:   prop<number | null>(null),
  invoiceDescription: prop<string | null>(null),
  invoiceError:       prop<string | null>(null),
  parsingInvoice:     prop<boolean>(false),
  indicativeDeposit: prop<string | null>(null),
  quoteErrors:        prop<string[]>(() => []),
  quoting:            prop<boolean>(false)
}) {
  @modelAction
  setAsset = (asset: PayInAssetCode) => {
    this.asset = asset;
    this.indicativeDeposit = null;
    this.quoteErrors = [];
  };

  @modelAction
  setBolt11 = (bolt11: string) => {
    this.bolt11 = bolt11;
    this.asset = null;
    this.parsedBolt11 = null;
    this.invoiceSats = null;
    this.invoiceExpiresAt = null;
    this.invoiceDescription = null;
    this.invoiceError = null;
    this.parsingInvoice = false;
    this.indicativeDeposit = null;
    this.quoteErrors = [];
  };

  @modelAction
  setParsingInvoice = (v: boolean) => {
    this.parsingInvoice = v;
  };

  @modelAction
  setInvoiceResult = (
    invoice: string,
    sats: number | null,
    expiresAt: number | null,
    error: string | null,
    description: string | null = null
  ) => {
    this.parsedBolt11 = error ? null : invoice;
    this.invoiceSats = sats;
    this.invoiceExpiresAt = expiresAt;
    this.invoiceDescription = error ? null : description;
    this.invoiceError = error;
  };

  @modelAction
  setQuoteResult = (deposit: string | null, errors: string[]) => {
    this.indicativeDeposit = deposit;
    this.quoteErrors = errors;
  };

  @modelAction
  setQuoting = (v: boolean) => {
    this.quoting = v;
  };

  @modelAction
  reset = () => {
    this.asset = null;
    this.bolt11 = "";
    this.parsedBolt11 = null;
    this.invoiceSats = null;
    this.invoiceExpiresAt = null;
    this.invoiceDescription = null;
    this.invoiceError = null;
    this.parsingInvoice = false;
    this.indicativeDeposit = null;
    this.quoteErrors = [];
    this.quoting = false;
  };
}
